import React, { useState, useEffect } from 'react';
import ContactForm from './ContactForm';
import ContactInfo from './ContactInfo';
import SocialLinks from './SocialLinks';
import { motion } from 'framer-motion';
import styles from './Contact.module.css';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    message: ''
  });

  useEffect(() => {
    emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
  }, []);

  const handleSubmit = async (formData) => {
    try {
      console.log('EmailJS Config:', {
        serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
        templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
        formData
      });

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: formData.name,
          from_email: formData.email,
          subject: formData.subject,
          message: formData.message,
        }
      );
      
      setFormStatus({
        submitted: true,
        success: true,
        message: 'Thank you for your message! Please check your email for confirmation.'
      });
    } catch (error) {
      console.error('EmailJS Error:', error);
      setFormStatus({
        submitted: true,
        success: false,
        message: 'Something went wrong. Please try again later.'
      });
    }
  };

  return (
    <section className={styles.contactSection}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className={styles.contactWrapper}
      >
        <h2 className={styles.sectionTitle}>Get in Touch</h2>
        <div className={styles.contactContent}>
          <ContactInfo />
          <ContactForm 
            onSubmit={handleSubmit}
            formStatus={formStatus}
          />
          <SocialLinks />
        </div>
      </motion.div>
    </section>
  );
};

export default Contact;
